import { CreateProOrganizerRequestDto } from '@smatchy/sdk';
import { ProOrganizerRequest } from '../domains';

export class CreateProOrganizerRequest {
  static readonly type = '[ProOrganizer] Create';
  constructor(public payload: CreateProOrganizerRequestDto & { id?: string }) {}
}

export class CreateProOrganizerSuccess {
  static readonly type = '[ProOrganizer] Create Success';
  constructor(public response: ProOrganizerRequest) {}
}

export class CreateProOrganizerFail {
  static readonly type = '[ProOrganizer] Create Fail';
  constructor(public error: unknown) {}
}
